import MultiSelectInput from '@repo/ui/multiselect-input'
import { useQuery } from '@tanstack/react-query'

import { getCountries } from '../../../../api/countries/get-countries'
import { FormulaFilters } from '../../../../lib/types/models/formula/formula'

type Props = {
  filter?: FormulaFilters
  onFilterChange: (filter: FormulaFilters) => void
}

const FormulaFilter = ({ filter, onFilterChange }: Props) => {
  const { data } = useQuery({
    queryKey: ['countries'],
    queryFn: () => getCountries()
  })

  function setFilter<K extends keyof FormulaFilters>(key: K, value: FormulaFilters[K]) {
    onFilterChange({ ...filter, [key]: value })
  }
  return (
    <div className="mt-5">
      <MultiSelectInput
        searchable
        label={'Formule de séjour'}
        variant={'primary'}
        options={data?.data?.map((country) => ({ label: country.name, value: +country.id }))}
        onChange={(countries) => setFilter('countries', countries)}
        selectedOptions={filter?.countries?.map((country) => ({
          label: data?.data?.find((c) => c.id === country)?.name || '',
          value: country
        }))}
      />
    </div>
  )
}

export default FormulaFilter
